function smoothScroll() {
    var links = $('a[href*="#"]:not([href="#"]):not(".link-with-hash")');

    function scrollTo($target) {
        $('html, body').animate({
            scrollTop: $target.offset().top - 100
        }, 500);
    }
    links.on('click', function(e) {
        var id = "#" + $(this).attr('href').split("#").slice(-1)[0];
        var $target = $(id);
        if ($target.length) {
            e.preventDefault();
            scrollTo($target);
        }
    });
}
module.exports = smoothScroll;